import { Link } from "@reach/router";
import * as clipboard from "clipboard-polyfill/text";
import { formatCurrency } from "js/services/Format";
import UserCountry from 'js/services/UserCountry';
import AppUser from "js/stores/AppUser";
import UserDashboardPageState from "js/stores/pages/UserDashboardPageState";
import PubSub from "pubsub-js";
import React from "react";

const DashboardCards = () => {
  const [stats, setStats] = React.useState({});
  const page = UserDashboardPageState.create();

  React.useEffect(async () => {
    await page.load();
    setStats(page);
  }, []);

  const copyText = (text) => {
    PubSub.publish('popup-text', 'Link copied!');
    clipboard
      .writeText(text)
      .then(() => {
        setCopiedItem(item);
      })
      .catch(() => { });
  };

  return (
    <>
      <div className="dashboard-cards">
        <div className="item-card">
          <div className="item-card__icon">
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
              <path
                d='M512 142.78v2.56q-.75 6.03-3.68 8.96-48.67 48.71-96.13 96.14-3.92 3.92-7.91 4.96c-16.05 4.18-27.07-15.22-15.52-26.77q34.27-34.28 68.02-68.03.59-.58-.24-.58-218.14-.08-438.04.03-5.47 0-8.85-1.44-7.79-3.33-9.65-12.72v-3.88q1.93-9.3 9.38-12.53 3.49-1.52 10.61-1.51 218.9.04 436.65 0 .7 0 .21-.49-33.64-33.72-66.4-66.31-4.27-4.25-5.38-7.41c-3.32-9.49 1.89-19.34 11.73-21.37 7.14-1.48 11.53 1.33 16.78 6.57q46.76 46.72 93.51 93.45 4.25 4.25 4.91 10.37ZM512 366.28v3.55q-1.89 9.45-9.49 12.71-3.51 1.51-8.78 1.5-220.48-.16-438.38 0-.69 0-.2.48 33.56 33.5 66.8 66.74 3.46 3.46 4.76 6.5c5.78 13.45-8.41 27.02-21.63 20.64q-2.5-1.21-6.45-5.15-48.51-48.51-94.81-94.82-3.15-3.15-3.82-9.21v-2.57q.73-6 3.81-9.09 46.4-46.37 92.77-92.78 6.36-6.37 8.93-7.43c16.59-6.85 30.22 13.57 17.48 26.3L55.24 351.4a.36.36 0 0 0 .25.61q217.06-.02 439.91-.01c8.77 0 14.88 5.42 16.6 14.28Z' />
            </svg>
          </div>
          <div className='item-card__content'>
            <div className='stats'>
              {stats.transactions || "---"}
            </div>
            Transactions
          </div>
          <div className='item-card__link text-center'>
            <Link
              to={'/dashboard/transactions'}
              className="btn-share d-flex align-items-center justify-content-center"
            >
              Current Transactions
            </Link>
          </div>
        </div>

        <div className="item-card">
          <div className="item-card__icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 20">
              <path
                d="M4.875 8.85a.735.735 0 0 1-.67-.387.666.666 0 0 1 .02-.763L8.4 1.025a.695.695 0 0 1 .622-.35c.269 0 .478.117.628.35L13.825 7.7c.167.25.173.504.02.763a.735.735 0 0 1-.67.387h-8.3ZM14.65 20c-1.233 0-2.267-.417-3.1-1.25-.833-.833-1.25-1.867-1.25-3.1s.417-2.267 1.25-3.1c.833-.833 1.867-1.25 3.1-1.25s2.267.417 3.1 1.25c.833.833 1.25 1.867 1.25 3.1s-.417 2.267-1.25 3.1c-.833.833-1.867 1.25-3.1 1.25Zm-13.9-.625a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534v-6.1c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216h6.1c.213 0 .39.072.534.216a.725.725 0 0 1 .216.534v6.1c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216H.75Zm13.902-.875c.799 0 1.473-.276 2.023-.827.55-.551.825-1.226.825-2.025 0-.799-.276-1.473-.827-2.023-.551-.55-1.226-.825-2.025-.825-.799 0-1.473.276-2.023.827-.55.552-.825 1.227-.825 2.025 0 .799.276 1.473.827 2.023.551.55 1.226.825 2.025.825ZM1.5 17.875h4.6v-4.6H1.5v4.6ZM6.225 7.35h5.6l-2.8-4.525-2.8 4.525Z" />
            </svg>
          </div>
          <div className="item-card__content">
            <div className="stats">
              {stats.num_items || 0}
            </div>
            Items
            <span className="store-value">
            <span>Checkout Value</span>
              {formatCurrency(stats.store_value || 0, UserCountry() === 'NG' ? 'NGN' : 'USD')}
          </span>
          </div>
          <div className="item-card__link">
            <Link to="/dashboard/items/create" className="btn-share d-flex align-items-center justify-content-center">
              + Create an item to sell
            </Link>
          </div>
        </div>

        <div className="item-card">
          <div className="item-card__icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
              <path
                d="M11.975 19.575c-.3.3-.662.45-1.088.45-.425 0-.787-.15-1.087-.45L.425 10.2a1.312 1.312 0 0 1-.337-.525A1.885 1.885 0 0 1 0 9.1V1.5C0 1.067.142.708.425.425.708.142 1.067 0 1.5 0h7.6c.2 0 .4.03.6.087.2.059.383.171.55.338l9.325 9.325c.317.317.475.688.475 1.113 0 .425-.158.795-.475 1.112l-7.6 7.6ZM10.95 18.55l7.6-7.6L9.1 1.5H1.5v7.6l9.45 9.45ZM4.125 5.4c.35 0 .654-.13.912-.388.259-.258.388-.562.388-.912s-.13-.654-.388-.912a1.248 1.248 0 0 0-.912-.388c-.35 0-.654.13-.913.388a1.248 1.248 0 0 0-.387.912c0 .35.13.654.387.913.259.258.563.387.913.387Z" />
            </svg>
          </div>
          <div className="item-card__content">
            <div className="stats">
              {stats.num_tokens || 0}
            </div>
            Offers
          </div>
          <div className="item-card__link">
            <Link to="/dashboard/offers" onClick={(e) => {openOfferModal(e)}} className="btn-share d-flex align-items-center justify-content-center">
              + Create offer link
            </Link>
          </div>
        </div>

        <div className="item-card">
          <div className="item-card__icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path
                d="M6.1 13.05c.35.767.78 1.37 1.288 1.813.508.441 1.137.762 1.887.962v.675c0 .183.07.342.213.475.141.133.304.2.487.2a.63.63 0 0 0 .475-.213.691.691 0 0 0 .2-.487v-.6c1.017-.117 1.808-.43 2.375-.938s.85-1.187.85-2.037c0-.85-.242-1.542-.725-2.075-.483-.533-1.3-1.042-2.45-1.525-.967-.4-1.667-.758-2.1-1.075a1.5 1.5 0 0 1-.65-1.275c0-.517.187-.925.562-1.225.375-.3.888-.45 1.538-.45.5 0 .933.117 1.3.35.367.233.675.583.925 1.05l1.2-.575c-.283-.583-.658-1.042-1.125-1.375-.467-.333-1.017-.533-1.65-.6v-.6a.649.649 0 0 0-.2-.475.649.649 0 0 0-.475-.2.691.691 0 0 0-.488.2.63.63 0 0 0-.212.475v.6c-.85.117-1.52.43-2.012.938S6.575 6.2 6.575 6.95c0 .817.25 1.467.75 1.95.5.483 1.25.933 2.25 1.35 1.117.467 1.883.887 2.3 1.262.417.375.625.838.625 1.388 0 .533-.22.963-.662 1.287-.442.325-.996.488-1.663.488-.65 0-1.23-.183-1.738-.55-.508-.367-.862-.867-1.062-1.5L6.1 13.05ZM10 20a9.676 9.676 0 0 1-3.875-.788 10.144 10.144 0 0 1-3.188-2.15 10.142 10.142 0 0 1-2.15-3.187A9.676 9.676 0 0 1 0 10c0-1.383.263-2.683.787-3.9a9.994 9.994 0 0 1 2.15-3.175A10.25 10.25 0 0 1 6.126.788 9.676 9.676 0 0 1 10 0c1.383 0 2.683.263 3.9.787a10.098 10.098 0 0 1 3.175 2.138c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 20 10a9.676 9.676 0 0 1-.788 3.875 10.25 10.25 0 0 1-2.137 3.188 9.994 9.994 0 0 1-3.175 2.15A9.738 9.738 0 0 1 10 20Zm0-1.5c2.367 0 4.375-.83 6.025-2.488C17.675 14.354 18.5 12.35 18.5 10c0-2.367-.825-4.375-2.475-6.025C14.375 2.325 12.367 1.5 10 1.5c-2.35 0-4.354.825-6.013 2.475C2.33 5.625 1.5 7.633 1.5 10c0 2.35.83 4.354 2.487 6.012C5.646 17.671 7.65 18.5 10 18.5Z" />
            </svg>
          </div>
          <div className="item-card__content">
            <div className="stats">
              {formatCurrency(AppUser.balance, UserCountry() === 'NG' ? 'NGN' : 'USD')}
            </div>
            Earned
          </div>
          <div className="item-card__link">
          </div>
        </div>
      </div>

    </>

  );
};

export default DashboardCards;
